import { render, staticRenderFns } from "./ObjectComments.vue?vue&type=template&id=65c18104&scoped=true"
import script from "./ObjectComments.vue?vue&type=script&lang=js"
export * from "./ObjectComments.vue?vue&type=script&lang=js"
import style0 from "./ObjectComments.vue?vue&type=style&index=0&id=65c18104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c18104",
  null
  
)

export default component.exports